<template>
  <div
    class="banner"
    @click="downLoadApp"
  >
    <img :src="bg" alt="">
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    bg: String
  },
  data () {
    return {
      // url: require('../assets/banner.png')
    }
  },
  watch: {},
  computed: {},
  methods: {
    // linkToHome() {
    //   this.$router.push('./')
    //   this.$nextTick(() => {
    //     document.getElementById('part1').scrollIntoView()
    //   })
    // },
    downLoadApp(){
      this.$emit('downFn');
    }
  },
  created () {},
  mounted () {}
}
</script>
<style scoped>
.banner {
  width: 100%;
  /* padding-bottom: 42%; */
}
.banner img {
  width: 100%;
}
</style>